<template>
    <div class="Form">
        <transition name="up-fade" appear>
            <form class="Form" @submit="submitStep($event)">
                <input-field
                    v-for="(field, index) in form.schema"
                    v-bind:class="field.class"
                    v-bind:key="index"
                    v-model="field.model"
                    :validations="$v.form.message"
                    :definition="{
                        id: 'formField-'+index,
                        label: field.label,
                        type: field.type,
                        disabled: disableForm,
                        required: field.required,
                        placeholder: field.placeholder,
                    }"
                    v-on:blurmessage="validateInput($v.form.message); updatedForm = true"
                    v-on:input="formSubmitted = false; updatedForm = true"
                    v-on:invalid="console.log($event); disableForm = true"></input-field>

                <transition name="slide-fade">
                    <div class="Form-inputError" v-if="asyncFormError">{{asyncFormError}}</div>
                </transition>

                <transition name="up-fade">
                    <button class="Button" :disabled="disableForm || !updatedForm" type="submit" @click="submitStep($event)">Save</button>
                </transition>

                <transition name="up-fade">
                    <p class="Info" v-if="formSubmitted">Saved.</p>
                </transition>
            </form>
        </transition>
    </div>
</template>

<script>
    import axios from "axios";
    // import { required } from 'vuelidate/lib/validators';
    import InputField from './input-field.vue';
    import cookieModel from '../models/cookie';

    // noinspection JSUnusedGlobalSymbols
    export default {
        components: {
            InputField
        },
        mounted() {
            const vm = this;

            if (!cookieModel.getCookie('ticketlab_access')) {
                console.log('no cookie', cookieModel.getCookie('ticketlab_access'));
                vm.asyncFormError = "An error has occurred with your authentication. Please log out and back in again to see if this resolves the issue."
                vm.disableForm = true;
                // vm.$rollbar.error(vm.asyncFormError);
            }
        },
        props: {
            schema: JSON,
            url: String
        },
        methods: {
            validateInput: function(subject) {
                console.log('validating', subject);
                subject.$touch();
            },

            submitStep: function (evt) {
                let vm = this;
                let url = vm.url;
                let postData = {};
                let skipSubmit = false;
                let analyticsAction = '';
                let analyticsEventObject = {
                    event_category: 'engagement',
                    event_label: ''
                };

                evt.preventDefault();
                if (!vm.disableForm) {
                    vm.disableForm = true;

                    // go through schema and add to postData
                    vm.form.schema.forEach(function (field) {
                        postData[field.name] = field.model;
                    });

                    console.log(postData);
                    analyticsAction = 'add_post-sale_message';
                    analyticsEventObject.event_label = 'Message Added';

                    if (!cookieModel.getCookie('ticketlab_access')) {
                        vm.asyncFormError = "An error has occurred with your authentication."
                        skipSubmit = true;
                        // vm.$rollbar.error(vm.asyncFormError);
                    }

                    if (skipSubmit) {
                        if (window.gtag) {
                            window.gtag('event', analyticsAction, analyticsEventObject);
                        }

                    } else {
                        vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer '+ cookieModel.getCookie('ticketlab_access');

                        vm.axiosInstance.post(url, postData)
                            .then(function (response) {
                                console.log('response: ', response.data)
                                if (response.data) {
                                    const responseData = response.data;
                                    // reset error
                                    vm.asyncFormError = false;

                                    if (window.gtag) {
                                        console.log('Google Analytics installed');
                                        window.gtag('event', analyticsAction, analyticsEventObject);
                                    } else {
                                        console.log('No Google Analytics installed');
                                    }

                                    if (responseData.status === 'success') {
                                        vm.$emit('message-updated', vm.form.message);
                                        vm.formSubmitted = true;
                                    } else {
                                        vm.asyncFormError = responseData.reason;
                                        // vm.$rollbar.error(vm.asyncFormError);
                                    }

                                    vm.disableForm = false;
                                } else {
                                    console.log('nada', response);
                                }
                            }).catch(function (error) {
                                console.log(error.response, error);
                                if (error.response && error.response.data) {
                                    if (error.response.data.reason) {
                                        vm.asyncFormError = error.response.data.reason;
                                    }
                                    if (error.response.data.message && error.response.statusText){
                                        vm.asyncFormError = error.response.statusText+': '+error.response.data.message;
                                    }
                                    // if response.data is an object, it's a validation error. Loop through and display all errors
                                    if (typeof error.response.data === 'object') {
                                        let errorString = '';
                                        for (let key in error.response.data) {
                                            console.log(key, error.response.data[key][0]);
                                            errorString += error.response.data[key][0] + ' ';
                                        }
                                        vm.asyncFormError = errorString;
                                    }
                                }

                                if (error.response && error.response.reason){
                                    vm.asyncFormError = error.response.reason;
                                }

                                if (error.response && error.response.message){
                                    vm.asyncFormError = error.response.message;
                                }
                                // vm.$rollbar.error(vm.asyncFormError);
                                vm.disableForm = false;
                            });
                    }
                }
            },
        },
        validations: {
            form: {
            },
        },
        data: function () {
            return {
                baseUrl: process.env.VUE_APP_API_URL,
                axiosInstance: axios.create({
                    baseURL: this.baseUrl,
                }),
                form: {
                    schema: this.schema
                },
                asyncFormError: false,
                disableForm: false,
                updatedForm: false,
                formSubmitted: false,
            }
        }
    }
</script>
